var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Password",
    d: "M78.929,8.43a2,2,0,0,0,.02-.35A8.327,8.327,0,0,0,75.3,1L75.185.929a6.465,6.465,0,0,0-.7-.369C74.421.533,74.37.5,74.309.47q-.285-.12-.57-.21a5.728,5.728,0,0,0-.56-.14,5.554,5.554,0,0,0-.853-.1l-.054,0C72.181.01,72.091,0,72,0c-3.83,0-6.95,3.63-6.95,8.08a2,2,0,0,0,.02.35A4.128,4.128,0,0,0,62,12.41v7.47A4.123,4.123,0,0,0,66.129,24h11.74A4.123,4.123,0,0,0,82,19.88V12.41a4.128,4.128,0,0,0-3.07-3.98m-5.42,7.51v2.4a1.511,1.511,0,0,1-3.02,0V15.93a1.94,1.94,0,0,1-.49-1.3,2,2,0,1,1,4,0,1.965,1.965,0,0,1-.49,1.31m2.43-7.65h-7.88a1.478,1.478,0,0,1-.01-.21c0-2.45,1.36-4.5,3.16-4.98A3.418,3.418,0,0,1,72,3a3.089,3.089,0,0,1,1.17.23,5.1,5.1,0,0,1,2.78,4.85,1.478,1.478,0,0,1-.01.21",
    transform: "translate(-61.999)",
    fill: "#E65847"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIconActive);
export default __webpack_public_path__ + "static/media/PasswordIconActive.006e0b2a687b0b6ac03fbd89c44d7cca.svg";
export { ForwardRef as ReactComponent };